import { Copy, Download } from 'lucide-react';
import { useBranding } from '../lib/theme.js';
import { Button } from './ui.js';

/**
 * Recovery codes, the one time they are shown: when someone sets up two-factor sign-in, and
 * when they make new ones in their settings. The server keeps only their hashes, so they
 * cannot be shown again; copying or downloading them is how they are kept.
 */
export function RecoveryCodes({ codes, account }: { codes: string[]; account: string }) {
  const product = useBranding()?.product_name ?? '';
  const download = () => {
    const text = [
      `${product} recovery codes for ${account}`,
      'Each code signs you in once, in place of a code from your authenticator app.',
      '',
      ...codes,
      '',
    ].join('\n');
    const url = URL.createObjectURL(new Blob([text], { type: 'text/plain' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = 'recovery-codes.txt';
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 10_000);
  };
  return (
    <div className="space-y-2">
      <ol
        data-testid="recovery-codes"
        className="grid grid-cols-2 gap-x-6 gap-y-1 rounded-md border border-slate-200 bg-slate-50 px-4 py-3 font-mono text-sm text-slate-800"
      >
        {codes.map((code) => (
          <li key={code}>{code}</li>
        ))}
      </ol>
      <div className="flex gap-2">
        <Button
          size="sm"
          onClick={() => void navigator.clipboard?.writeText(`${codes.join('\n')}\n`)}
        >
          <Copy className="size-4" aria-hidden /> Copy
        </Button>
        <Button size="sm" onClick={download}>
          <Download className="size-4" aria-hidden /> Download
        </Button>
      </div>
    </div>
  );
}
